module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-retornos-modal/reporte-resumen-de-obra-retornos-modal.component.scss
// module id = ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-retornos-modal/reporte-resumen-de-obra-retornos-modal.component.scss
// module chunks = main